module.exports = "\r\n<div class=\"layui-row\">\r\n    <div class=\"layui-col-md9\">\r\n        <input type=\"input\" lay-verify=\"{{verify}}\" lay-verType=\"tips\" name=\"{{fieldName}}\" class=\"layui-input select-search-input\" />\r\n    </div>\r\n    <div class=\"layui-col-md3\">\r\n        <div class=\"noteNum\" data-bind=\"text:codeMsg,click:getCode,css:{disabled:noteNone()}\"></div>\r\n    </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/template/form/SmsVerify.html
// module id = 77
// module chunks = 0